export default __webpack_public_path__ + "static/Incorrect logo use 1 – 1600x800-8c51112e6f24b96488e26cfdcb9556c6.jpg";